import { BarcodeIcon, BoxIcon, CircleCheckBigIcon, Layers2Icon, RulerIcon } from 'lucide-react';

import type { SkuDTO } from '@invenco/products-interface';

import { Badge } from '@/components/core/badge';
import { DialogTrigger } from '@/components/core/dialog';
import { DetailEditButton, DetailList } from '@/components/detail-list';
import { FormDialog } from '@/components/forms/form-dialog';
import type { Result } from '@/shared/helpers/Result';

import {
  fulfillmentStrategyTitle,
  skuTypeTitle,
  skuUnitTypeTitle,
  unitOfMeasureTitle,
} from '../../../../shared/title-maps';
import { DetailsDialogContent } from './details-dialog-content';

type Props = {
  sku?: Partial<SkuDTO>;
  isLoading?: boolean;
  onSubmit: (data: Partial<SkuDTO>) => Promise<Result> | Promise<void> | void;
};

export function DetailsSection({ sku, isLoading, onSubmit }: Props) {
  return (
    <FormDialog>
      <DetailList
        title="Details"
        isLoading={isLoading}
        action={
          <DialogTrigger asChild>
            <DetailEditButton disabled={isLoading} />
          </DialogTrigger>
        }
        items={[
          { icon: BarcodeIcon, label: 'Barcode', value: sku?.barcode },
          {
            icon: Layers2Icon,
            label: 'Type',
            value: sku?.type ? (
              <Badge variant="secondary">{skuTypeTitle[sku.type]}</Badge>
            ) : undefined,
          },
          {
            icon: BoxIcon,
            label: 'Unit type',
            value: sku?.unitType ? (
              <Badge variant="secondary">{skuUnitTypeTitle[sku.unitType]}</Badge>
            ) : undefined,
          },
          {
            icon: RulerIcon,
            label: 'Measure',
            value: sku?.unitOfMeasure ? (
              <Badge variant="secondary">{unitOfMeasureTitle[sku.unitOfMeasure]}</Badge>
            ) : undefined,
          },
          {
            icon: CircleCheckBigIcon,
            label: 'Fulfillment',
            value: sku?.fulfillmentStrategy ? (
              <Badge variant="secondary">{fulfillmentStrategyTitle[sku.fulfillmentStrategy]}</Badge>
            ) : undefined,
          },
        ]}
      />
      <DetailsDialogContent sku={sku} onSubmit={onSubmit} />
    </FormDialog>
  );
}
